import React from 'react';
import PropTypes from 'prop-types';
import {
  Typography,
  CardHeader,
  Button,
  CardContent,
} from '@mui/material';
import { connect } from 'react-redux';
import {
  deleteComment,
  editComment as editCommentAction,
} from '@pingum/app-state-management/comment/actions';

import User from '../../../User';
import { getUser } from '../../../../utils/userHelper';
import { getCommentStringFromMentionString } from '../../../../utils/mentionsHelper';
import { formatDateString } from '../../../../utils/dateHelper';
import HistoryActionsMenu from '../HistoryActionMenu';
import UserMentionTextField from '../../../UserMentionTextField';

export class HistoryItemComponent extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      editMode: false,
      editComment: null,
    };
  }

  deleteComment = () => {
    this.props.deleteComment(this.props.item.id);
  }

  editComment = () => {
    this.setState({ editMode: true });
  }

  editModeCancel = () => {
    this.setState({
      editMode: false,
      editComment: null,
    });
  }

  editModeSave = () => {
    if (this.state.editComment) {
      this.props.editComment(this.props.item.id, { comment: this.state.editComment });
    }
    this.setState({
      editMode: false,
      editComment: null,
    });
  }

  handleCommentChange = (e) => {
    this.setState({ editComment: e.target.value });
  }

  render() {
    const {
      permissions,
      item,
      classes,
      children,
      isDeletingComment,
      isEditingComment,
      hideActions,
      event,
    } = this.props;
    const {
      editMode,
      editComment,
    } = this.state;
    const cardClasses = [classes.card];

    return (
      <div className={classes.container}>
        <div className={cardClasses.join(' ')}>
          <CardHeader
            classes={{
              root: classes.cardHeader,
              avatar: classes.cardAvatar,
              content: classes.cardHeaderContent,
            }}
            avatar={(
              <User
                user={getUser({
                  email: item.createdByEmail,
                  userFullName: item.createdByName,
                })}
                secondary={formatDateString(item.createdDate)}
                userAction={(
                  <span>
                    &nbsp;added a <strong>comment</strong>
                    {
                      !!event
                        && (
                          <span>
                            &nbsp;for <strong>{event.name}</strong> <Typography variant="caption" className={classes.eventIdField}>(#{event.id})</Typography>
                          </span>
                        )
                    }
                  </span>
                )}
              />
            )}
            action={
              (permissions.owner || permissions.admin) && !hideActions
                ? (
                  <HistoryActionsMenu
                    isLoading={isDeletingComment || isEditingComment}
                    onDelete={this.deleteComment}
                    onEdit={this.editComment}
                  />
                )
                : undefined
            }
          />
          <CardContent className={classes.comment} classes={{ root: classes.commentLastChild }}>
            <div className={classes.body}>
              {
                !editMode
                  ? (
                    <Typography variant="body1" className={classes.commentText} component="div">
                      {getCommentStringFromMentionString(item.comment)}
                    </Typography>
                  )
                  : (
                    <div className={classes.editContainer}>
                      <UserMentionTextField
                        value={editComment || item.comment}
                        label="Comment"
                        onChange={this.handleCommentChange}
                      />
                      <div className={classes.buttonContainer}>
                        <Button
                          onClick={this.editModeCancel}
                          size="small"
                          className={classes.cancelButton}
                        >
                          Cancel
                        </Button>
                        <Button
                          onClick={this.editModeSave}
                          disabled={!editComment}
                          size="small"
                          className={classes.saveButton}
                          color="primary"
                          variant="contained"
                        >
                          Save
                        </Button>
                      </div>
                    </div>
                  )
              }
            </div>
          </CardContent>
        </div>
        {
          children
        }
      </div>
    );
  }
}

HistoryItemComponent.propTypes = {
  classes: PropTypes.object,
  permissions: PropTypes.object,
  item: PropTypes.object,
  children: PropTypes.any,
  isDeletingComment: PropTypes.bool,
  isEditingComment: PropTypes.bool,
  deleteComment: PropTypes.func,
  editComment: PropTypes.func,
  hideActions: PropTypes.bool,
  event: PropTypes.object,
};

HistoryItemComponent.defaultProps = {
  classes: {},
  permissions: {},
  item: {},
  children: null,
  isDeletingComment: false,
  isEditingComment: false,
  deleteComment: () => {},
  editComment: () => {},
  hideActions: false,
  event: null,
};

export const mapStateToProps = (state) => ({
  permissions: state.user.permissions,
  isDeletingComment: state.comment.isDeletingComment,
  isEditingComment: state.comment.isEditingComment,
});

export const mapDispatchToProps = (dispatch) => ({
  deleteComment: (id) => dispatch(deleteComment(id)),
  editComment: (id, request) => dispatch(editCommentAction(id, request)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(HistoryItemComponent);
